import { defineMessages } from 'react-intl';

const messages = defineMessages({
  newVersionAvailable: {
    id: 'appVersion.newVersionAvailable',
    defaultMessage: 'A new version of the app is available.',
  },
  refresh: {
    id: 'appVersion.refresh',
    defaultMessage: 'Refresh',
  },
});

export default messages;
